import {ReactNode} from 'react';
import {VerifiedPermissionsProvider} from '@flexinet/auth-components';
import {useAuth} from '../hooks/useAuth.ts';
import permissions from '../config/permissions.ts';
import {actions} from '../config/rbac/actions.ts';

// FNP-1731: the shared provider evaluates permissions only once this app's own
// AuthContext has resolved the session, and again whenever the user changes.
export const PermissionsProvider = ({children}: { children?: ReactNode }) => {
    const {status, user} = useAuth();

    return (
        <VerifiedPermissionsProvider
            actions={[...actions]}
            policyStoreId={permissions.policyStoreId}
            region={permissions.region}
            actionType={'Action'}
            enabled={permissions.enabled}
            sessionStatus={status}
            sessionKey={status === 'authenticated' ? user?.userId : undefined}
        >
            {children}
        </VerifiedPermissionsProvider>
    );
};
